<div class="cmps-cdk-border-radius-4p cmps-cdk-bg-color-grey-200">
    <cmps-accordion [multi]="true">
        <ng-container *ngFor="let g of _caResult?.groups; let gl = last">
            <cmps-accordion-item
                class="cmps-cdk-border-width-0p cmps-cdk-border-solid cmps-cdk-border-color-grey-300"
                [class.cmps-cdk-border-b-width-1p]="!gl"
                [isOpen]="!_collapsed"
                #item
            >
                <!-- TODO public accessor for cmps-accordion-item -> isOpen -->
                <!-- TODO public accessor for cmps-accordion-header click -->
                <cmps-accordion-header
                    class="cmps-ca-evaluation--header cmps-cdk-bg-color-transparent cmps-cdk-mb-0 cmps-cdk-py-0"
                    [class.cmps-cdk-border-b-width-1p]="item._isOpen"
                    [class.cmps-cdk-border-b-solid]="item._isOpen"
                    [class.cmps-cdk-border-b-color-grey-300]="item._isOpen"
                    (click)="_onHeaderClick(g, !item._isOpen)"
                >
                    <div
                        class="cmps-cdk-flex-grow-1 cmps-cdk-font-size-15p cmps-cdk-font-bold cmps-cdk-text-center"
                    >
                        <div>{{ g?.label }}</div>
                    </div>
                    <div class="cmps-cdk-font-size-20p cmps-cdk-font-bold">
                        {{ g?.scorePercent ?? 0 | cmpsPercent: '1.0-0' }}
                    </div>
                </cmps-accordion-header>
                <cmps-accordion-content>
                    <div class="cmps-cdk-d-flex">
                        <div
                            class="cmps-cdk-px-1dot5 cmps-cdk-py-0dot5 cmps-cdk-flex-100"
                        >
                            <ng-container *ngFor="let a of g?.areas">
                                <div
                                    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-font-size-14p cmps-cdk-mb-0dot25 last-child:cmps-cdk-mb-auto"
                                    [class.cmps-cdk-border-width-1p]="
                                        a?.doNotEvaluate !== true
                                    "
                                    [class.cmps-cdk-border-solid]="
                                        a?.doNotEvaluate !== true
                                    "
                                    [class.cmps-cdk-border-color-transparent]="
                                        a?.doNotEvaluate !== true &&
                                        a?.evaluatedBool === true
                                    "
                                    [class.cmps-cdk-border-color-blue-100]="
                                        a?.doNotEvaluate !== true &&
                                        a?.evaluatedBool !== true
                                    "
                                    [class.cmps-ca-analysis-dialog--bg-color]="
                                        a?.doNotEvaluate !== true &&
                                        a?.evaluatedBool !== true
                                    "
                                >
                                    <div class="cmps-cdk-mr-1">
                                        <cmps-icon
                                            class="cmps-cdk-fill-green-100"
                                            svgIcon="check-circle"
                                            *ngIf="
                                                a?.doNotEvaluate !== true &&
                                                a?.evaluatedBool === true
                                            "
                                        ></cmps-icon>
                                        <cmps-icon
                                            class="cmps-cdk-fill-blue-100"
                                            svgIcon="alert-circle"
                                            *ngIf="
                                                a?.doNotEvaluate !== true &&
                                                a?.evaluatedBool !== true
                                            "
                                        ></cmps-icon>
                                        <cmps-icon
                                            class="cmps-cdk-fill-grey-400"
                                            svgIcon="circle-off-outline"
                                            *ngIf="a?.doNotEvaluate === true"
                                        ></cmps-icon>
                                    </div>
                                    <cmps-ts-tooltip-conditional
                                        selector=".cmps-cdk-line-clamp-2"
                                    >
                                        <ng-container ngProjectAs="show">
                                            <div
                                                class="cmps-cdk-line-clamp-2"
                                                [class.cmps-cdk-font-bold]="
                                                    a?.doNotEvaluate !== true &&
                                                    a?.evaluatedBool === true
                                                "
                                                [class.cmps-cdk-color-green-100]="
                                                    a?.doNotEvaluate !== true &&
                                                    a?.evaluatedBool === true
                                                "
                                                [class.cmps-cdk-color-blue-100]="
                                                    a?.doNotEvaluate !== true &&
                                                    a?.evaluatedBool !== true
                                                "
                                                [cmpsTooltipTrigger]="a?.label"
                                            >
                                                <span>{{ a?.label }}</span>
                                            </div>
                                        </ng-container>
                                        <ng-container ngProjectAs="no-show">
                                            <div
                                                class="cmps-cdk-line-clamp-2"
                                                [class.cmps-cdk-font-bold]="
                                                    a?.doNotEvaluate !== true &&
                                                    a?.evaluatedBool === true
                                                "
                                                [class.cmps-cdk-color-green-100]="
                                                    a?.doNotEvaluate !== true &&
                                                    a?.evaluatedBool === true
                                                "
                                                [class.cmps-cdk-color-blue-100]="
                                                    a?.doNotEvaluate !== true &&
                                                    a?.evaluatedBool !== true
                                                "
                                            >
                                                <span>{{ a?.label }}</span>
                                            </div>
                                        </ng-container>
                                    </cmps-ts-tooltip-conditional>
                                    <div
                                        class="cmps-cdk-ml-auto"
                                        [cmpsTooltipTrigger]="
                                            a?.evaluatedReasoning
                                        "
                                        *ngIf="
                                            a?.doNotEvaluate !== true &&
                                            a?.evaluatedReasoning != null
                                        "
                                    >
                                        <cmps-icon
                                            class="cmps-cdk-fill-grey-300"
                                            svgIcon="information"
                                        ></cmps-icon>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </cmps-accordion-content>
            </cmps-accordion-item>
        </ng-container>
    </cmps-accordion>
</div>
